import styled, { device } from '@styled'

export const ContactInfoWrapper = styled.div`
  position: relative;
  isolation: isolate;
  padding-block-start: 53px;
  padding-block-end: 60px;
  ${device.medium} {
    padding-block-start: 73px;
    padding-block-end: 80px;
  }
  ${device.large} {
    padding-block-start: 91px;
    padding-block-end: 100px;
  }
`
